import ganttChartStyles from "../../styles/ganttChart/ganttChart.module.css";
import colors from "../../utils/colors";
import TinyDivider from "../UI/TinyDivider";
import GreyOpacityText from "../UI/textFields/GreyOpacityText";
import labels from "../../utils/labels";

const KPIListOverview = ({
  continuity,
  distance,
}: {
  continuity: number;
  distance?: number;
}) => {
  return (
    <div className="flex gap-[--spacing-sm] items-center">
      <div
        className="flex gap-[--spacing-sm] items-center whitespace-nowrap"
        style={{ fontWeight: 500 }}
      >
        <span
          className={ganttChartStyles.kpiBullet}
          style={{
            backgroundColor: colors.getBackgroundColor(continuity),
          }}
        ></span>
        {continuity} {labels.affinity}
      </div>
      <TinyDivider colorVariant="PRIMARY"></TinyDivider>
      <div className="flex gap-[--spacing-sm] items-center whitespace-nowrap">
        {distance ? distance : "-"} Km
      </div>
    </div>
  );
};

export default KPIListOverview;
